<template>
  <div class="row">
    <div class="col-xs-5">
      <select
        ref="payment_term"
        :value="payment_term"
        :title="$t('Days')"
        class="form-control"
        name="payment_term"
        style="max-width: 60px; float: left; font-size: 12px"
        @change="$emit('update:payment_term', $event.target.value)"
      >
        <option
          v-for="payment_termOption in payment_termOptions"
          :key="payment_termOption"
          :value="payment_termOption"
        >
          {{ payment_termOption }}
        </option>
      </select>
      <span class="iblock p-t-10 f-12 p-l-5">{{ $t('Days') }}</span>
    </div>
    <div class="col-xs-7">
      <div class="small">
        <div class="radio">
          <label>
            <input
              :checked="payment_term_method == 'net'"
              type="radio"
              name="payment_term_method"
              value="net"
              @input="$emit('update:payment_term_method', $event.target.value)"
            />
            {{ $t('Net (accounting)') }}
            <i class="input-helper" />
          </label>
        </div>
        <div class="radio">
          <label>
            <input
              :checked="payment_term_method == 'end of month'"
              type="radio"
              name="payment_term_method"
              value="end of month"
              @input="$emit('update:payment_term_method', $event.target.value)"
            />
            {{ $t('From end of month') }}
            <i class="input-helper" />
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nextTick } from 'vue'

export default {
  props: {
    payment_term: { type: [Number, String], default: 8 },
    payment_term_method: { type: String, default: 'net' },
  },
  data() {
    return {
      payment_termOptions: [8, 14, 30, 45, 53, 60, 75, 90],
    }
  },
  methods: {
    focus() {
      nextTick(() => this.$refs.payment_term.focus?.())
    },
  },
}
</script>
